/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

type Props = SVGProps<SVGSVGElement> & {
    mode: 'light' | 'dark';
};

export default function DefaqtoIcon({ mode, ...props }: Props) {
    const theme = useTheme();

    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="129"
            height="26"
            viewBox="0 0 129 26"
            {...props}
            role="img"
        >
            <path
                fill={mode === 'dark' ? theme.colors.dark : '#fff'}
                d="M18.04 20.676v-1.522h-.052c-.796 1.294-2.234 1.979-4.263 1.979-4.315 0-7.14-3.274-7.14-7.536s2.903-7.485 7.062-7.485c1.644 0 2.98.482 4.187 1.674V1.898h4.263v18.778h-4.059.001Zm.025-7.106c0-1.953-1.515-3.527-3.621-3.527-2.107 0-3.596 1.471-3.596 3.527 0 2.057 1.516 3.629 3.57 3.629s3.647-1.549 3.647-3.629ZM28.224 14.913c.231 1.6 1.592 2.665 3.338 2.665 1.156 0 1.901-.432 2.594-1.32h4.367c-1.362 3.07-3.955 4.873-6.96 4.873-4.11 0-7.551-3.274-7.551-7.46 0-4.187 3.287-7.562 7.474-7.562 4.186 0 7.525 3.324 7.525 7.69 0 .406-.025.736-.102 1.116H28.225l-.001-.002Zm6.523-2.841c-.334-1.446-1.619-2.411-3.262-2.411-1.54 0-2.877.913-3.21 2.41h6.472ZM41.527 20.671V9.786h-1.593V6.588h1.593v-.583c0-2.335.924-4.466 5.47-4.466h1.792V4.71h-1.357c-1.104 0-1.644.28-1.644 1.446v.43h3.001v3.199h-3V20.67h-4.264l.002.001ZM61.072 20.673v-1.521h-.052c-.616 1.242-2.31 2.004-4.186 2.004-4.212 0-7.14-3.274-7.14-7.536s3.056-7.51 7.14-7.51c1.746 0 3.365.685 4.186 1.978h.052V6.59h4.263v14.083h-4.263Zm-.107-7.983c-.24-1.049-1-1.921-2.006-2.336-2.58-1.068-4.957.75-5 3.248-.034 1.927 1.512 3.58 3.463 3.62 2.34.049 4.112-2.045 3.543-4.532ZM79.024 25.354v-6.127h-.051c-.924 1.244-2.388 1.904-4.314 1.904-3.981 0-6.884-3.198-6.884-7.232 0-4.466 2.928-7.79 7.14-7.79 1.823 0 3.416.686 4.238 2.03h.051V6.59h4.084v18.764h-4.264Zm.138-12.06c-.18-1.883-1.867-3.335-3.78-3.248-1.893.087-3.344 1.582-3.344 3.675 0 1.903 1.593 3.477 3.57 3.477a3.548 3.548 0 0 0 3.553-3.905ZM87.218 20.676V9.79H85.11V6.593h2.107V1.898h4.263v4.695h2.994V9.79H91.48v10.885h-4.263ZM102.958 21.104c-4.34 0-7.678-3.173-7.678-7.486s3.415-7.485 7.678-7.485 7.68 3.171 7.68 7.435c0 4.263-3.39 7.536-7.68 7.536Zm3.416-7.486c0-1.878-1.438-3.552-3.441-3.552-1.876 0-3.39 1.624-3.39 3.552 0 1.929 1.489 3.553 3.415 3.553 1.927 0 3.416-1.675 3.416-3.553Z"
            />
            <path
                fill="url(#a)"
                d="m128.756 6.54-5.451 3.91-1.284-3.91h6.735Z"
            />
            <path
                fill="#FF7000"
                d="m111.121 6.54 12.184 3.91L119.939.21l-2.08 6.332-6.738-.001Z"
            />
            <path
                fill="url(#b)"
                d="m111.121 6.54 12.184 3.91 2.083 6.33-5.449-3.914-5.45 3.915 2.084-6.332-5.452-3.91Z"
            />
            <defs>
                <linearGradient
                    id="a"
                    x1="118.531"
                    x2="127.388"
                    y1="9.932"
                    y2="6.775"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".4" stopColor="#973386" />
                    <stop offset=".42" stopColor="#9F377B" />
                    <stop offset=".57" stopColor="#C84F46" />
                    <stop offset=".71" stopColor="#E56120" />
                    <stop offset=".81" stopColor="#F86C08" />
                    <stop offset=".87" stopColor="#FF7000" />
                </linearGradient>
                <linearGradient
                    id="b"
                    x1="110.625"
                    x2="118.122"
                    y1="1.491"
                    y2="12.748"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".54" stopColor="#973386" />
                    <stop offset=".56" stopColor="#9F377B" />
                    <stop offset=".71" stopColor="#C84F46" />
                    <stop offset=".84" stopColor="#E56120" />
                    <stop offset=".94" stopColor="#F86C08" />
                    <stop offset="1" stopColor="#FF7000" />
                </linearGradient>
            </defs>
        </svg>
    );
}
